import { TextField, Button, Typography, Container, Paper } from "@mui/material";
import { styled, createTheme } from "@mui/material/styles";

// Custom theme for retro-neon aesthetics
export const theme = createTheme({
  palette: {
    primary: {
      main: "#00ffff", // Neon cyan
    },
    secondary: {
      main: "#ff00ff", // Neon pink
    },
    background: {
      default: "#121212", // Dark retro background
      paper: "#1d1d1d", // Slightly lighter for cards or containers
    },
    text: {
      primary: "rgb(251, 6, 137)", // White for main text
      secondary: "#b3b3b3", // Grey for subtitles
    },
  },
  typography: {
    fontFamily: '"Press Start 2P", "Roboto", "Arial", sans-serif',
    button: {
      textTransform: "none", // Prevent all-uppercase buttons
    },
  },
});

// Styled components using MUI's styled utility
export const NeonButton = styled(Button)(({ theme }) => ({
    background: `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
    color: 'whitesmoke',
    boxShadow: `0 0 10px ${theme.palette.primary.main}, 0 0 20px ${theme.palette.secondary.main}`,
    borderRadius: "8px",
    padding: "10px 20px",
    "&:hover": {
      background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
      boxShadow: `0 0 20px ${theme.palette.primary.main}, 0 0 40px ${theme.palette.secondary.main}`,
    },
  }));

  export const NeonTextField = styled(TextField)(({ theme }) => ({
    "& .MuiInputBase-root": {
      color: theme.palette.text.primary, // Correct text color reference
      caretColor: theme.palette.primary.main, // Neon caret
      backgroundColor: theme.palette.background.paper, // Dark contrasting background
      borderRadius: "4px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.main, // Default border color
      },
      "&:hover fieldset": {
        borderColor: theme.palette.secondary.main, // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.secondary.main, // Focused border color
        boxShadow: `0 0 10px ${theme.palette.secondary.main}`, // Neon glow
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary, // Label color
    },
  }));
  
  
export const NeonContainer = styled(Container)(({ theme }) => ({
    textAlign: "center",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    background: "rgba(0,0,0,1)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1) //Reduce padding on small screen sizes
    }
  }));
  
export const NeonQRBox = styled(Paper)(({ theme }) => ({
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
    background: theme.palette.background.paper,
    border: `3px solid ${theme.palette.secondary.main}`,
    boxShadow: `0 0 20px ${theme.palette.primary.main}, 0 0 40px ${theme.palette.secondary.main}`,
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2), //Reduce padding on small screens
    }
  }));
  
export const NeonTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    textShadow: `0 0 10px ${theme.palette.secondary.main}, 0 0 20px ${theme.palette.primary.main}`,
    fontSize: "2rem", //Default size
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem"
    }
  }));